import type { Anomaly } from '@gozoki/api-types'
import { useQuery } from '@tanstack/react-query'

export const useAnomalies = (storeId: number) =>
  useQuery<Anomaly[], Error>({
    queryKey: ['anomalies', storeId],
    queryFn: () => [],
    initialData: [] as Anomaly[],
  })
